import { lazy } from "react";
const Products = lazy(() => import("./Products"));
const Overview = lazy(() => import("./Overview"));
const ProductLayout = lazy(() => import("../layouts"));
import { ProductProvider } from "@/modules/product";

const Routes = () => {
	const baseUrl = "/products";

	return [
		{
			path: baseUrl,
			element: (
				<ProductProvider>
					{" "}
					<Products />
				</ProductProvider>
			),
		},
		{
			path: `${baseUrl}/:productId`,
			element: <ProductLayout />,
			children: [
				{
					path: "",
					element: <Overview />,
				},
			],
		},
	];
};

export { Routes };
